var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M72 24L24 72M24 24L72 72","stroke":"#130A09","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

X.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = X;

X.default = X;
